import { render } from "./FormularioUnidades.vue?vue&type=template&id=291d32c0&scoped=true"
import script from "./FormularioUnidades.vue?vue&type=script&lang=js"
export * from "./FormularioUnidades.vue?vue&type=script&lang=js"

import "./FormularioUnidades.vue?vue&type=style&index=0&id=291d32c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291d32c0"]])

export default __exports__